var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import { objectReduce, arrayEach } from 'fast-loops';
import isPlainObject from 'isobject';

function multipleSelectors(style) {
  return objectReduce(style, function (normalizedStyle, value, property) {
    if (isPlainObject(value)) {
      var resolvedValue = multipleSelectors(value);

      arrayEach(property.split(','), function (selector) {
        var key = selector.trim();

        // merge styles with base styles
        var baseStyle = normalizedStyle[key] || {};
        normalizedStyle[key] = _extends({}, baseStyle, resolvedValue);
      });
    } else {
      normalizedStyle[property] = value;
    }

    return normalizedStyle;
  }, {});
}

export default (function () {
  return multipleSelectors;
});